import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelPackageReasonEntity } from '../../domain/entities/CancelPackageReasonEntity'

export class CancelPackageReasonModel extends CancelPackageReasonEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}
